import { Box, Flex, Container } from '@chakra-ui/react';

interface MobileNavbarProps {
  children: React.ReactNode;
}
const MobileNavbar = (props: MobileNavbarProps) => {
  const { children } = props;

  return (
    <Box
      as="nav"
      display={{ base: 'flex', lg: 'none' }}
      bgColor="chakra-subtle-bg"
      borderBottomWidth="1px"
      alignItems="center"
      position="fixed"
      left={0}
      right={0}
      top={0}
      zIndex="docked"
      height="3.75rem"
    >
      <Container>
        <Flex>{children}</Flex>
      </Container>
    </Box>
  );
};

export default MobileNavbar;
